module.exports = __webpack_public_path__ + "img/FR_checkIntegrity.4145f370.png";